import { useState } from 'react';
import { isLength } from 'validator';

import { ERROR_VALIDATE_ORDER } from '../lib/Error';
import { updateContactInfo } from '../domain/order/ContactInfo/ContactInfoAPI';
import { useInput } from './useInput';

export const CONTACTINFO_VALIDATE = {
  name: (value) => !isLength(value, { min: 2, max: 10 }),
  mobile: (value) => !isLength(value, { min: 10, max: 11 }),
  detailAddress: (value) => !isLength(value, { min: 1 }),
};

export const useContactInfo = (initialState) => {
  const [changeStatus, setChangeStatus] = useState(false);

  const {
    state,
    setValue,
    setValueAll,
    onChangeValue,
    onKeyPress,
    onValidate,
    onChange,
  } = useInput({
    initialState: {
      name: initialState.contactName,
      mobile: initialState.mobile,
      zipcode: initialState.zipcode,
      address: initialState.address,
      detailAddress: initialState.detailAddress,
      nameError: null,
      mobileError: null,
      detailAddressError: null,
      isLoading: false,
      isEditLoading: false,
    },
    validate: CONTACTINFO_VALIDATE,
    error: ERROR_VALIDATE_ORDER,
  });

  const { name, mobile, zipcode, address, detailAddress } = state;

  const onClickUpdateContactInfo = (id) => {
    if (
      CONTACTINFO_VALIDATE.name(name) ||
      CONTACTINFO_VALIDATE.mobile(mobile) ||
      CONTACTINFO_VALIDATE.detailAddress(detailAddress)
    ) {
      alert('에러 메세지를 확인해주세요');
    } else {
      setValue({ name: 'isEditLoading', value: false });
      updateContactInfo({
        id,
        contactName: name,
        mobile,
        zipcode,
        address,
        detailAddress,
      })
        .then((response) => {
          setChangeStatus(false);
          setValueAll({
            object: {
              name: response.contactInfo.contactName,
              mobile: response.contactInfo.mobile,
              zipcode: response.contactInfo.zipcode,
              address: response.contactInfo.address,
              detailAddress: response.contactInfo.detailAddress,
              nameError: null,
              mobileError: null,
              detailAddressError: null,
              isLoading: false,
            },
          });
        })
        .finally(() => {
          setValue({ name: 'isLoading', value: false });
        });
    }
  };

  const onClickCancelEdit = () => {
    setChangeStatus(false);
    setValueAll({
      object: {
        name: initialState.contactName,
        mobile: initialState.mobile,
        zipcode: initialState.zipcode,
        address: initialState.address,
        detailAddress: initialState.detailAddress,
        nameError: null,
        mobileError: null,
        detailAddressError: null,
        isLoading: false,
      },
    });
  };

  return {
    state,
    setValue,
    setValueAll,
    onValidate,
    onKeyPress,
    onChangeValue,
    onChange,
    onClickUpdateContactInfo,
    changeStatus,
    setChangeStatus,
    onClickCancelEdit,
  };
};
